import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { AcademicYear as AcademicYearType, SemesterItem } from '../../types';
import { Course } from '../course/Course';
import styles from './academic-year.module.css';
import classNames from 'classnames';

export type AcademicYearProps = {
    academicYear: AcademicYearType;
    className?: string;
    hideTitle?: boolean;
    /** Takes the place of the credit total. */
    headerEnd?: ReactNode;
    onOpenItem: (item: SemesterItem) => void;
};

export const AcademicYear = ({ academicYear, className, hideTitle, headerEnd, onOpenItem }: AcademicYearProps) => {
    const { t } = useTranslation();
    const totalCredits = academicYear.semesters.reduce((total, semester) => total + (semester.credits || 0), 0);

    return (
        <div className={classNames(styles.academicYear, className)}>
            {!hideTitle && (
                <div className={styles.header}>
                    <h3>{academicYear.title}</h3>
                    {headerEnd ?? (totalCredits > 0 && <p>{t('credits', { count: totalCredits })}</p>)}
                </div>
            )}
            <div className={styles.semesters}>
                {academicYear.semesters.map((semester) => (
                    <div key={semester.id} className={styles.semester}>
                        <h4>{semester.title}</h4>
                        <ul className={styles.courseList}>
                            {semester.items.map((item) => (
                                <Course key={item.id} course={item} onOpenItem={onOpenItem} />
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
};
